import { render, staticRenderFns } from "./BlockLoader.vue?vue&type=template&id=755dbaed"
var script = {}
import style0 from "./BlockLoader.vue?vue&type=style&index=0&id=755dbaed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports